import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Typography from 'kingpin/atoms/Typography';
import ListItemWrapper from '../../../DatasetDefinitions/ListItemWrapper';
import Column from '../../../DatasetDefinitions/Column';
import { getMetricLink } from '../../../AllSets/routes';
import Card from '../../../../../components/Common/Card';
import { PortalsContext } from '../../../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/PortalsProvider';

const MetricsUsage = ({
  metrics,
  usedId,
}: {
  metrics: Metrics.NormalMetric[];
  usedId: string;
}) => {
  const { selectedPortal } = useContext(PortalsContext);

  return (
    <>
      {metrics.length > 0 && (
        <div style={{ marginBottom: 24 }}>
          <div style={{ marginBottom: '8px' }}>
            <Typography.Header type="H5">
              {`Metrics (${metrics.length})`}
            </Typography.Header>
          </div>

          <Card>
            {metrics.map((m, index) => (
              <ListItemWrapper
                key={`${m.id}-${usedId}`}
                isLast={metrics.length - 1 === index}
              >
                <Column
                  style={{
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                  }}
                >
                  <Link
                    to={getMetricLink({
                      metric: m,
                      portal: selectedPortal,
                    })}
                    target="_blank"
                    style={{ display: 'flex' }}
                  >
                    <Typography.Body
                      type="Body 12"
                      color="var(--color-info-v2)"
                    >
                      {m.name}
                    </Typography.Body>
                  </Link>
                </Column>
              </ListItemWrapper>
            ))}
          </Card>
        </div>
      )}
    </>
  );
};

export default MetricsUsage;
